import * as React from 'react';
import cn from 'classnames';

import { Outside } from '@cian/ui-kit/prev/outside';

import { CheckIcon } from './assets';

import * as styles from './styles.css';

export interface IDropdownValue<V> {
  value: V;
  label: string;
}

export interface IDropdownProps<V> {
  value: V;
  values: IDropdownValue<V>[];
  onChange(value: V): void;
}

export interface IDropdownState {
  active: boolean;
}

export class Dropdown<V> extends React.Component<IDropdownProps<V>, IDropdownState> {
  public state: IDropdownState = {
    active: false,
  };

  public render() {
    const { value, values, onChange } = this.props;
    const { active } = this.state;

    const label = (values.find(item => item.value === value) || {}).label;

    if (!label) {
      return null;
    }

    return (
      <Outside onOutside={this.handleOutsideClick}>
        <div className={styles['container']}>
          <button
            type="button"
            className={cn(styles['control-button'], active && styles['control-button--active'])}
            onClick={this.handleButtonClick}
          >
            {label}
          </button>
          {active && (
            <div className={styles['dropdown']}>
              <ul className={styles['list']}>
                {values.map(option => (
                  <li key={`${option.value}`}>
                    <button
                      type="button"
                      className={styles['button']}
                      onClick={() => {
                        onChange(option.value);
                        this.setState({ active: false });
                      }}
                    >
                      {option.label}
                      {option.value === value && (
                        <span className={styles['button-active-icon']}>
                          <CheckIcon />
                        </span>
                      )}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </Outside>
    );
  }

  private handleButtonClick = () => {
    this.setState(state => ({
      active: !state.active,
    }));
  };

  private handleOutsideClick = () => {
    this.setState({
      active: false,
    });
  };
}
